import "@/App.css";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";
import { toast } from "sonner";

import { LanguageProvider } from "@/i18n/LanguageProvider";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Bases from "@/components/Bases";
import Menu from "@/components/Menu";
import SocialProof from "@/components/SocialProof";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

import { getMenu } from "@/lib/api";

function Shell() {
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const m = await getMenu();
        setMenu(m);
      } catch (e) {
        console.error("Init error", e);
        toast.error("Couldn't reach the kitchen. Please refresh.");
      }
    })();
  }, []);

  return (
    <div className="App" data-testid="tirami-app">
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#211512",
            color: "#FFF8EE",
            border: "1px solid #C5A059",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <Nav />
      <Hero />
      <Marquee />
      <Story />
      <Bases />
      <Menu items={menu} />
      <SocialProof />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Shell />
    </LanguageProvider>
  );
}
